export const config = {
	from: {
		textField: {
			label: 'Début',
			hint: 'Format JJ/MM/AAAA'
		}
	},
	to: {
		textField: {
			label: 'Fin',
			hint: 'Format JJ/MM/AAAA'
		}
	}
};
